




export default {
    name: 'DateTimeDisplay',

    props: {
        date: {
            required: true,
            type: String,
        },
        time: {
            default: false,
            required: false,
            type: Boolean,
        },
        timeOnly: {
            default: false,
            required: false,
            type: Boolean,
        },
    },

    computed: {
        formattedDate() {
            if (this.time) {
                if (this.timeOnly) {
                    return this.$dayjs(this.date).format('HH:mm:ss');
                } else {
                    return this.$dayjs(this.date).format('DD/MM/YYYY HH:mm:ss');
                }
            }

            return this.$dayjs(this.date).format('DD/MM/YYYY');
        },
    },
};
